import { createWebHistory, createRouter } from "vue-router";
import toastr from "toastr";
import routes from "./routes";
import appConfig from "../../app.config";
import { langWeb } from "@/stores/lang";
import i18n from "../i18n";
const { t } = i18n.global;
import mushroom from "cem-primary-api";
import { Filter, Project } from "mushroomjs";

const router = createRouter({
  history: createWebHistory(),
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
});

router.beforeEach(async function (to, from, next) {
  if (to.query.type_login === "probe" || to.query.type_login === "bras") {
    localStorage.setItem("type_login", to.query.type_login);
  }
  let countCheck = 0;
  const lang_web = langWeb();
  if (from.name != to.name) {
    if (to.meta.page && to.meta.page == "admin") {
      try {
        const response = await mushroom.$auth.meAsync();
        if (response.result) {
          if (response.result.roles?.length > 0) {
            response.result.roles.forEach((item) => {
              if (
                to.meta.allowAccess.includes(item) ||
                to.meta.allowAccess[0] === "*"
              ) {
                countCheck++;
              }
            });
            localStorage.setItem("userInfo", JSON.stringify(response));
          }
          if (countCheck === 0) {
            next("/no-permission");
          } else {
            // Đa ngôn ngữ task 90
            // Bước 1: Kiểm tra localStorage key "language"
            if (localStorage.getItem("language")) {
              i18n.global.locale = localStorage.getItem("language");
              lang_web.changeLanguage(localStorage.getItem("language"));
              next();
            }
            // Bước 2: Kiểm tra localStorage key "language_default"
            else if (localStorage.getItem("language_default")) {
              i18n.global.locale = localStorage.getItem("language_default");
              lang_web.changeLanguage(localStorage.getItem("language_default"));
              // Nhảy xuống bước 4 (system_config đã có rồi, kết thúc)
              next();
            }
            // Bước 3: Gọi user_config API
            else {
              const langUserConfig = await mushroom.user_config.getAllAsync({
                fields: Project.include("id", "key", "value").build(),
                filters: Filter.eq("key", "language").build(),
              });
              if (langUserConfig.result?.length > 0) {
                i18n.global.locale = langUserConfig.result[0].value;
                lang_web.changeLanguage(langUserConfig.result[0].value);
                localStorage.setItem(
                  "language",
                  langUserConfig.result[0].value,
                );
                next();
              }
              // Nếu không có user_config và localStorage đã có key language thì kết thúc
              else if (localStorage.getItem("language")) {
                next();
              }
              // Bước 4: Gọi system_config API
              else {
                const langSystemConfig = await mushroom.system_config.listAsync(
                  {
                    fields: Project.include("id", "key", "value").build(),
                    filters: Filter.eq("key", "language_default").build(),
                  },
                );
                if (langSystemConfig.result?.length > 0) {
                  i18n.global.locale = langSystemConfig.result[0].value;
                  lang_web.changeLanguage(langSystemConfig.result[0].value);
                  localStorage.setItem(
                    "language_default",
                    langSystemConfig.result[0].value,
                  );
                  next();
                }
                // Nếu không có system_config và localStorage đã có key language_default thì kết thúc
                else if (localStorage.getItem("language_default")) {
                  next();
                }
                // Bước 5: Fallback tiếng Việt (không lưu localStorage)
                else {
                  i18n.global.locale = "vi";
                  lang_web.changeLanguage("vi");
                  next();
                }
              }
            }
          }
        }
      } catch (error) {
        if (error.code >= 1 && error.code <= 9) {
          toastr.error(t("toastr_internet_connection_error"));
          return;
        }
        window.localStorage.clear();
        next("/login");
      }
    } else if (to.meta.page && to.meta.page != "admin") {
      next();
    } else {
      next("/error");
    }
  } else if (from.name && to.name && from.name == to.name) {
    next();
  } else {
    if (!to.name) {
      next("/error");
    } else next("/login");
  }
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
    }
  } catch (error) {
    return;
  }
  document.title = routeTo.meta.title + " | " + appConfig.title;
  next();
});

export default router;
